import React from "react";
import { useHistory } from "react-router-dom";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";

const ArrowBackIcon = ({ className }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 19l-7-7 7-7"
    />
  </svg>
);

const TicketHeader = ({ loading, children }) => {
  const history = useHistory();

  const handleBack = () => {
    history.push("/tickets");
  };

  if (loading) {
    return <TicketHeaderSkeleton />;
  }

  return (
    <div className="flex items-center gap-2 px-3 py-2 bg-dark-50 dark:bg-dark-900 border-b border-dark-200 dark:border-dark-700 min-h-[60px]">
      <button
        onClick={handleBack}
        className="md:hidden p-2 text-primary-600 dark:text-primary-400 hover:bg-dark-100 dark:hover:bg-dark-800 rounded-lg transition-colors flex-shrink-0"
      >
        <ArrowBackIcon className="w-5 h-5" />
      </button>
      {children}
    </div>
  );
};

export default TicketHeader;
